import { MarkerPin04 } from "@untitledui/icons";

import { Tooltip, TooltipTrigger } from "@/components/ui/tooltip/tooltip";

type UseMapCenterButtonProps = {
	onClick: () => void;
	visible?: boolean;
};

const USE_MAP_CENTER_TOOLTIP =
	"Use the map center to set the longitude and latitude coordinates";

/** Places coordinates from the current map viewport (shared across create/edit map forms). */
export const UseMapCenterButton = ({
	onClick,
	visible = true,
}: UseMapCenterButtonProps) => {
	if (!visible) return null;

	return (
		<Tooltip placement="top" title={USE_MAP_CENTER_TOOLTIP}>
			<TooltipTrigger
				aria-label={USE_MAP_CENTER_TOOLTIP}
				className="inline-flex shrink-0 text-fg-quaternary hover:text-fg-quaternary_hover"
				onClick={onClick}
			>
				<MarkerPin04 aria-hidden className="size-4" />
			</TooltipTrigger>
		</Tooltip>
	);
};
